import { render, staticRenderFns } from "./switch-picker.vue?vue&type=template&id=be911c96&scoped=true"
import script from "./switch-picker.vue?vue&type=script&lang=js"
export * from "./switch-picker.vue?vue&type=script&lang=js"
import style0 from "./switch-picker.vue?vue&type=style&index=0&id=be911c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be911c96",
  null
  
)

export default component.exports